import React from 'react';
import { Box } from '@mui/material';

interface Props {
  errors: string[];
}

export const ErrorsSection: React.FC<Props> = ({ errors }) => {
  if (errors.length === 0) return;

  return (
    <Box
      sx={{
        color: 'red',
      }}
    >
      Error: {errors.at(0)}
    </Box>
  );
};
